import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import history from '../../../../history';
import { URL_AKM,CONFIG_API_BE } from '../../../../config';
import akmApi from '../../../../apis/akmApi';
import eduprimeApi from '../../../../apis/eduprimeApi';
import {cekCookies} from '../../../../actions';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import {Modal, Alert, Row, Col, Button} from 'react-bootstrap';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,IconButton,Typography,Collapse,Box, ButtonGroup} from '@material-ui/core';
import Select from 'react-select';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined';
import { get } from 'jquery';



class Account extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            alertShow: false,
            openModal: false,
            createAkun: false,
            resMessage: 'Error',
            roles: [],
            selectedRole: null,
            adminList: [],            
            provinsi: [],
            kodeJenjang: [],
            admin: {},
            levels: "",
            adminProvinsi: {},
            adminKabupaten: []
        }
    }

    async componentDidMount() { 

        //console.log(this.props.location.state)
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.fetchRole();
            this.fetchProvinsi();
            this.fetchKodeJenjang();
        }  
        
        if(!__.isUndefined(this.props.location.state)) {
            this.changeRole(this.props.location.state.role);
        }
        
    }

    fetchProvinsi = async() => {
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI);
        if(response){
            let data = [];
            if(response.status === 200){
                response.data.list_provinsi.map(value => {
                    const object = {
                        'value': value.ID_PROVINSI,
                        'label': value.NAMA_PROVINSI
                    }
                    data.push(object)
                })
            }            
            this.setState({provinsi: data})
        }
    }   

    fetchRole = async() => {
        this.setState({isLoading: true})
        const response = await akmApi.get(URL_AKM.GET_ADMIN_ROLE_ALL);
        if(response){
            let data = [];
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                response.data.data.map(value => {
                    const object = {
                        'value': value.idRole,
                        'label': value.namaRole + "("+ value.kategoriOwner +")"
                    }
                    data.push(object)
                })
            }            
            this.setState({roles: data, isLoading: false})
        }
    }

    fetchKodeJenjang = async() => {        
        const response = await akmApi.get(URL_AKM.GET_KODE_JENJANG);
        if(response){
            let data = [];
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                response.data.data.map(value => {
                    const object = {
                        'value': value.kodeJenjangSekolah,
                        'label': value.kodeJenjangSekolah
                    }
                    data.push(object)
                })
            }            
            this.setState({kodeJenjang:data})
        }
    }

    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 

    changeRole = async(selectedOption) => {        
        this.setState({selectedRole: selectedOption})
        this.setState({isFetching: true, adminList: []})
        const response = await akmApi.get(URL_AKM.GET_ADMIN_ROLE_BY_ID, {params: {idRole: selectedOption.value} });
        if(response){            
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                this.setState({ adminList: response.data.data})
            }                      
            this.setState({isFetching: false})
        }
    }

    createAkun = (admin, role, level) => {        
        history.push({
            pathname: '/addeditakun/' + role + '/' + level,
            state: {
                admin: admin,
                provinsi: this.state.provinsi,
                kodeJenjang: this.state.kodeJenjang,
                role: this.state.selectedRole === null ? {} : this.state.selectedRole
            }
        })     
    }

    

    render() {       
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title="Management Account"/>  
                    {this.loadAlert()}

                    <Row>
                        <Col sm={4}>                        
                            <Select
                                className="basic-single"
                                placeholder ="Pilih Role..."
                                classNamePrefix="select"
                                value={this.state.selectedRole}
                                isLoading={this.state.isLoading}
                                isSearchable={true}
                                name="role"
                                options={this.state.roles}
                                onChange={this.changeRole}
                            />
                        </Col>

                        <Col sm={8} style={{ textAlign: 'right'}}>
                            {this.state.selectedRole !== null && 
                            <button className="btn btn-outline-primary"                              
                            onClick={() => this.state.selectedRole.value === 12 ? 
                                this.setState({openModal: true}) : 
                                this.createAkun(this.state.admin, 1, "none") }
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i> tambah
                            </button> 
                            } 
                        </Col>
                        {this.renderModal()}
                        
                    </Row>
                    {this.state.adminList.length > 0 &&
                    <Table size="small" aria-label="purchases">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="left">Nama</TableCell>
                                <TableCell align="left">Username</TableCell>
                                <TableCell align="left">Level</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.state.adminList.map((data,i) =>   
                        <React.Fragment key={i}>                      
                        <TableRow >
                            <TableCell>
                                <ArrowRightOutlinedIcon aria-label="expand row" size="small" />                             
                            </TableCell>
                            <TableCell align="left">{data.namaAdminUser}</TableCell>
                            <TableCell align="left">{data.usernameAdmin}</TableCell>
                            <TableCell align="left">{data.levelAdminUser}</TableCell>                    
                            <TableCell align="right">
                                <div className="button-group">
                                {/* <button className="btn btn-outline-info btn-sm" onClick={() => this.setOpen(data)}><i className="fa fa-info-circle" aria-hidden="true"></i></button>&nbsp; */}
                                    <button className="btn btn-outline-warning btn-sm" onClick={() => this.createAkun(data, data.idRole, data.levelAdminUser)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>&nbsp;
                                    <button className="btn btn-outline-danger btn-sm" onClick={() => {if (window.confirm('Konfirmasi Hapus ?')) this.handleDelete(data)}}><i className="fa fa-trash-o" aria-hidden="true"></i></button>								
                                </div>
                            </TableCell>
                        </TableRow> 

                        {/* <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Collapse in={data.open} timeout="auto" unmountOnExit>
                                <Box margin={1}>                               
                                
                                <Table size="small" aria-label="mapel">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Provinsi</TableCell>
                                            <TableCell>Kabupaten</TableCell>
                                            <TableCell>Jenjang</TableCell>                                        
                                            <TableCell>#</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.adminKabupaten.map((kab,k) =>
                                        <TableRow key={k}>
                                            <TableCell component="th" scope="row">{this.state.adminProvinsi.label}</TableCell>
                                            <TableCell>{kab.namaKabupaten}</TableCell>                                
                                            <TableCell>{kab.kodeJenjangSekolah}</TableCell>
                                            <TableCell>4</TableCell>      
                                        </TableRow>
                                        )}  
                                    </TableBody>
                                </Table>
                                </Box>
                            </Collapse>
                            </TableCell>
                        </TableRow> */}
                        </React.Fragment>
                        )}
                        </TableBody>
                    </Table>
                    }
                </div>
            </div>
        )
    }

    fecthDinasDetails = async(idDinasPemda) => {
        this.setState({ adminKabupaten: [] })
        const response = await akmApi.get(URL_AKM.DINAS_DETAIL_GET_BY_ID_DINAS,
            {params: { idDinasPemda : idDinasPemda }});
        if(response){                    
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                let kab = [];
                response.data.data.map(async(res) => {                    
                    const getKab = await akmApi.get(URL_AKM.GET_KABUPATEN_BY_ID,{params: { idKabupatenKota : res.idKabupatenKota }});                    
                    if(getKab.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                        res.namaKabupaten = getKab.data.data.namaKabupatenKota;
                        kab.push(res);
                    }
                    
                })
                this.setState({ adminKabupaten: kab});
            } 
        }
    }



    setOpen = async(data) => {
        this.setState({ adminProvinsi: {}, adminKabupaten: [] })
        this.setState(state => ({
            ...state,
            adminList: this.state.adminList.map(item =>
              item.idAdmin === data.idAdmin ? { ...item, open: !data.open } : { ...item, open: false }
            )
        }));

        if(!data.open) {
            if(data.idRole === 12) {
                const idDinasPemda = data.idDinasPemda === null ? 0 : data.idDinasPemda;
                const response = await akmApi.get(URL_AKM.DINAS_PEMDA_GET_BY_ID,
                    {params: { idDinasPemda : idDinasPemda }});
                if(response){           
                    if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                        const prov = this.state.provinsi.find(p => p.value == response.data.data.idProvinsi)
                        this.setState({ adminProvinsi: { value: prov.value, label: prov.label} })
                        // this.fecthDinasDetails(idDinasPemda);

                        const getDetails = await akmApi.get(URL_AKM.DINAS_DETAIL_GET_BY_ID_DINAS,
                            {params: { idDinasPemda : idDinasPemda }});
                        if(getDetails){                    
                            if(getDetails.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                                let kab = [];
                                getDetails.data.data.map(async(res) => {                    
                                    const getKab = await akmApi.get(URL_AKM.GET_KABUPATEN_BY_ID,{params: { idKabupatenKota : res.idKabupatenKota }});                    
                                    if(getKab.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                                        res.namaKabupaten = getKab.data.data.namaKabupatenKota;
                                        kab.push(res);
                                    }
                                    
                                })
                                this.setState({adminKabupaten: kab})
                            } 
                        }
                    }            
                    
                }
            }
        }
    }

    handleDelete = async(data) => {
        if(window.confirm('Yakin...................?')) {
            this.setState({isFetching: true})
            if(data.idRole == 12) {
                const response = await akmApi.post(URL_AKM.DELETE_ADMIN, data);
                if(response){
                    this.setState({
                        adminList: this.state.adminList.filter(a => a.idAdmin !== data.idAdmin),
                        alertShow: true,
                        resMessage: "Ok.........."
                    }) 
                } else {
                    this.setState({
                        alertShow: true,
                        resMessage: "Failed.........."
                    }) 
                }
            } else {
                this.setState({
                    alertShow: true,
                    resMessage: 'Operation yet permitted...'
                })
            }
            this.setState({isFetching: false})
        }
        
    }

    handleOpen = () => {
        this.setState({ openModal: true})
    }

    renderModal(){
        const handleClose = () => this.setState({openModal: false});
        const handleOpen = (level) => { 
            this.setState({createAkun: true, levels: level});
            this.createAkun(this.state.admin, this.state.selectedRole === null ? null : this.state.selectedRole.value, level);
        }
        return(
            <Modal show={this.state.openModal} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                <Modal.Title>Select Level...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col style={{textAlign:'center'}}>
                            <button className="btn btn-outline-dark btn-lg" onClick={() => handleOpen('DINAS')}>Dinas</button>
                        </Col>

                        <Col style={{textAlign:'center'}}>
                            <button className="btn btn-outline-dark btn-lg" onClick={() => handleOpen('DINDIK')}>Dindik</button>
                        </Col>
                    </Row> 

                </Modal.Body>
            </Modal>
        )
    }

    

}

const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}
export default connect(mapStateToProps, {cekCookies})(Account);